import {UNIT_STATUS_OPTIONS} from "../../support/UnitStatus";
import React from "react";

export const UnitStatusSelector = ({currentStatus, unitStatus, onChange, errors}) => {

  const handleStatusChange = (event) => {
    onChange(event.target.value);
  }

  const hasError = errors && errors.length !== 0;

  return (
      <div className="relative">
        <select
            value={unitStatus}
            onChange={handleStatusChange}
              className={`appearance-none text-xs font-medium px-3 py-1 rounded-full pr-6 cursor-pointer focus:outline-none focus:ring-2 focus:ring-offset-1 ${
                  hasError
                      ? "border border-red-500 focus:ring-red-500"
                      : "border-0 focus:ring-orange-500"
              }`}
            style={{
              backgroundColor: currentStatus.bgColor,
              color: currentStatus.color
            }}
        >
          {Object.entries(UNIT_STATUS_OPTIONS).map(([key, option]) => (
              <option key={key} value={key}>
                {option.label}
              </option>
          ))}
        </select>
        <div
            className="absolute inset-y-0 right-1 flex items-center pointer-events-none">
          <svg className="w-3 h-3" style={{color: currentStatus.color}}
               fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                  d="M19 9l-7 7-7-7"/>
          </svg>
        </div>
        {hasError && (
            <p className="mt-1 text-xs text-red-500">{errors[0].defaultMessage}</p>
        )}
      </div>
  );
};